var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagicpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99988 22.3689C4.25988 22.3689 3.52988 22.0889 2.96988 21.5289C2.42988 20.9889 2.12988 20.2689 2.12988 19.4989C2.12988 18.7289 2.42988 18.0089 2.96988 17.4689L15.9699 4.46891C17.0899 3.34891 18.9099 3.34891 20.0299 4.46891C20.5699 5.00891 20.8699 5.72891 20.8699 6.49891C20.8699 7.26891 20.5699 7.98891 20.0299 8.52891L7.02988 21.5289C6.46988 22.0889 5.73988 22.3689 4.99988 22.3689ZM17.9999 5.12891C17.6499 5.12891 17.2999 5.25891 17.0299 5.52891L4.02988 18.5289C3.76988 18.7889 3.62988 19.1289 3.62988 19.4989C3.62988 19.8689 3.76988 20.2089 4.02988 20.4689C4.55988 20.9989 5.43988 20.9989 5.96988 20.4689L18.9699 7.46891C19.2299 7.20891 19.3699 6.86891 19.3699 6.49891C19.3699 6.12891 19.2299 5.78891 18.9699 5.52891C18.6999 5.25891 18.3499 5.12891 17.9999 5.12891Z",
    fill: "url(#paint0_linear_10773_38851)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.834 6.31348C14.9287 6.21874 15.0918 6.21874 15.1865 6.31348L18.1865 9.31348C18.2812 9.40822 18.2812 9.5713 18.1865 9.66602C18.1352 9.7173 18.0743 9.73926 18.0098 9.73926C17.9454 9.73916 17.8851 9.71715 17.834 9.66602L14.834 6.66602C14.7392 6.57128 14.7392 6.40821 14.834 6.31348Z",
    fill: "url(#paint1_linear_10773_38851)",
    stroke: "url(#paint2_linear_10773_38851)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 5.99907C9.95005 5.99907 9.91005 5.98907 9.86005 5.97907L8.50005 5.57907L7.14005 5.97907C6.96005 6.02908 6.77005 5.97907 6.65005 5.84907C6.52005 5.71907 6.47005 5.53908 6.52005 5.35908L6.92005 3.99907L6.52005 2.63907C6.47005 2.45907 6.52005 2.26907 6.65005 2.14907C6.78005 2.01907 6.97005 1.96907 7.14005 2.01907L8.50005 2.41907L9.86005 2.01907C10.0401 1.96907 10.2201 2.01907 10.3501 2.14907C10.4801 2.27907 10.5301 2.46907 10.4801 2.63907L10.0801 3.99907L10.4801 5.35908C10.5301 5.53908 10.4801 5.72907 10.3501 5.84907C10.2601 5.94907 10.1301 5.99907 10.0001 5.99907ZM8.50005 4.55907C8.55005 4.55907 8.59005 4.56907 8.64005 4.57907L9.26005 4.75908L9.08005 4.13908C9.05005 4.04908 9.05005 3.94907 9.08005 3.85907L9.26005 3.23907L8.64005 3.41907C8.55005 3.44907 8.45005 3.44907 8.36005 3.41907L7.74005 3.23907L7.92005 3.85907C7.95005 3.94907 7.95005 4.04908 7.92005 4.13908L7.74005 4.75908L8.36005 4.57907C8.41005 4.56907 8.45005 4.55907 8.50005 4.55907Z",
    fill: "url(#paint3_linear_10773_38851)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00005 11.9991C5.95005 11.9991 5.91005 11.9891 5.86005 11.9791L4.50005 11.5791L3.14005 11.9791C2.96005 12.0291 2.78005 11.9791 2.65005 11.8491C2.52005 11.7191 2.47005 11.5291 2.52005 11.3591L2.92005 9.99907L2.52005 8.63908C2.47005 8.45908 2.52005 8.26907 2.65005 8.14907C2.78005 8.02907 2.97005 7.96907 3.14005 8.01907L4.50005 8.41907L5.86005 8.01907C6.03005 7.96907 6.22005 8.01907 6.35005 8.14907C6.48005 8.27907 6.53005 8.46908 6.48005 8.63908L6.08005 9.99907L6.48005 11.3591C6.53005 11.5391 6.48005 11.7291 6.35005 11.8491C6.26005 11.9491 6.13005 11.9991 6.00005 11.9991ZM4.50005 10.5591C4.55005 10.5591 4.59005 10.5691 4.64005 10.5791L5.26005 10.7591L5.08005 10.1391C5.05005 10.0491 5.05005 9.94907 5.08005 9.85907L5.26005 9.23907L4.64005 9.41907C4.55005 9.44907 4.45005 9.44907 4.36005 9.41907L3.74005 9.23907L3.92005 9.85907C3.95005 9.94907 3.95005 10.0491 3.92005 10.1391L3.74005 10.7591L4.36005 10.5791C4.41005 10.5691 4.45005 10.5591 4.50005 10.5591Z",
    fill: "url(#paint4_linear_10773_38851)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0001 16.9991C20.9501 16.9991 20.9101 16.9891 20.8601 16.9791L19.5001 16.5791L18.1401 16.9791C17.9601 17.0291 17.7801 16.9791 17.6501 16.8491C17.5201 16.7191 17.4701 16.5291 17.5201 16.3591L17.9201 14.9991L17.5201 13.6391C17.4701 13.4591 17.5201 13.2691 17.6501 13.1491C17.7801 13.0291 17.9701 12.9691 18.1401 13.0191L19.5001 13.4191L20.8601 13.0191C21.0301 12.9691 21.2201 13.0191 21.3501 13.1491C21.4801 13.2791 21.5301 13.4691 21.4801 13.6391L21.0801 14.9991L21.4801 16.3591C21.5301 16.5391 21.4801 16.7291 21.3501 16.8491C21.2601 16.9491 21.1301 16.9991 21.0001 16.9991ZM19.5001 15.5591C19.5501 15.5591 19.5901 15.5691 19.6401 15.5791L20.2601 15.7591L20.0801 15.1391C20.0501 15.0491 20.0501 14.9491 20.0801 14.8591L20.2601 14.2391L19.6401 14.4191C19.5501 14.4491 19.4501 14.4491 19.3601 14.4191L18.7401 14.2391L18.9201 14.8591C18.9501 14.9491 18.9501 15.0491 18.9201 15.1391L18.7401 15.7591L19.3601 15.5791C19.4101 15.5691 19.4501 15.5591 19.5001 15.5591Z",
    fill: "url(#paint5_linear_10773_38851)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10773_38851",
    x1: 2.12988,
    y1: 0.626805,
    x2: 24.0092,
    y2: 2.88841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#012169"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.391034,
    stopColor: "#423398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9134D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10773_38851",
    x1: 14.2627,
    y1: 5.0217,
    x2: 19.5108,
    y2: 5.56388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#012169"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.391034,
    stopColor: "#423398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9134D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10773_38851",
    x1: 14.2627,
    y1: 5.0217,
    x2: 19.5108,
    y2: 5.56388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#012169"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.391034,
    stopColor: "#423398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9134D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10773_38851",
    x1: 6.50098,
    y1: 1.35936,
    x2: 11.1689,
    y2: 1.84176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#012169"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.391034,
    stopColor: "#423398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9134D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10773_38851",
    x1: 2.50098,
    y1: 7.35936,
    x2: 7.16892,
    y2: 7.84176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#012169"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.391034,
    stopColor: "#423398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9134D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10773_38851",
    x1: 17.501,
    y1: 12.3594,
    x2: 22.1689,
    y2: 12.8418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#012169"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.391034,
    stopColor: "#423398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9134D9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicpen);
export default __webpack_public_path__ + "static/media/magicpen.e6c0d1f7b700a972f3d1cc44e3855e34.svg";
export { ForwardRef as ReactComponent };